var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginImagen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 179,
    height: 184,
    viewBox: "0 0 179 184",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32620",
    "data-name": "Rect\\xE1ngulo 32620",
    width: 179,
    height: 184,
    transform: "translate(-15455 -9361)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_42739",
    "data-name": "Enmascarar grupo 42739",
    transform: "translate(15455 9361)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42865",
    "data-name": "Grupo 42865",
    transform: "translate(-5.108 33.03)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32621",
    "data-name": "Rect\\xE1ngulo 32621",
    width: 183.941,
    height: 183.817,
    transform: "translate(-15454.892 -9394.03)",
    fill: "#fcecf4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32622",
    "data-name": "Rect\\xE1ngulo 32622",
    width: 8.522,
    height: 35.181,
    transform: "translate(-15308.887 -9344.221)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32623",
    "data-name": "Rect\\xE1ngulo 32623",
    width: 13.921,
    height: 104.401,
    transform: "translate(-15405.125 -9355.262)",
    fill: "#7bc3bb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32624",
    "data-name": "Rect\\xE1ngulo 32624",
    width: 82.318,
    height: 104.401,
    transform: "translate(-15391.204 -9355.262)",
    fill: "#16ae97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21700",
    "data-name": "Trazado 21700",
    d: "M111.485,69.9a26.452,26.452,0,1,0,26.49,26.455A26.46,26.46,0,0,0,111.485,69.9m2.948,39.916a2.932,2.932,0,0,1-5.864,0v-.164a2.932,2.932,0,0,1,5.864-.1c0,.035,0,.069,0,.1Zm.1-10.219a.743.743,0,0,1-.1.029v1.619a2.932,2.932,0,0,1-5.864,0V99.389a5.55,5.55,0,0,1,4.064-5.347l.139-.034a3.975,3.975,0,1,0-5.255-3.757,2.932,2.932,0,0,1-5.864,0,9.844,9.844,0,1,1,12.879,9.35",
    transform: "translate(-15461.531 -9399.413)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32625",
    "data-name": "Rect\\xE1ngulo 32625",
    width: 8.522,
    height: 25.178,
    transform: "translate(-15308.887 -9309.04)",
    fill: "#ce1080"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_32626",
    "data-name": "Rect\\xE1ngulo 32626",
    width: 8.522,
    height: 25.181,
    transform: "translate(-15308.887 -9283.862)",
    fill: "#16ae97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21701",
    "data-name": "Trazado 21701",
    d: "M49.909,79.843v35.291H2.375A101.406,101.406,0,0,1,.9,79.846Z",
    transform: "translate(-15454.892 -9400.179)",
    fill: "#e49ac2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21702",
    "data-name": "Trazado 21702",
    d: "M51.152,97.954a20.068,20.068,0,0,0,11.6-9.045H74.365c6.114,0,5.716-9.059,0-9.059H51.152Z",
    transform: "translate(-15458.942 -9400.18)",
    fill: "#e49ac2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginImagen);
export default __webpack_public_path__ + "static/media/Login_imagen.1b39735b7a2b9f51e8db15fc6b8b678f.svg";
export { ForwardRef as ReactComponent };